// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file share_link_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file share_link_service.proto.
 */
export const file_share_link_service: GenFile = /*@__PURE__*/
  fileDesc("ChhzaGFyZV9saW5rX3NlcnZpY2UucHJvdG8SBmRvbWFpbiIwChdQcmV2aWV3U2hhcmVMaW5rUmVxdWVzdBIVCg1zaGFyZV9saW5rX2lkGAEgASgJIpYBChhQcmV2aWV3U2hhcmVMaW5rUmVzcG9uc2USGQoRZW5jcnlwdGVkX3BheWxvYWQYASABKAwSFAoMc2VuZGVyX2VtYWlsGAIgASgJEhkKEW9yZ2FuaXphdGlvbl9uYW1lGAMgASgJEi4KCmV4cGlyZXNfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIi0KFFNob3dTaGFyZUxpbmtSZXF1ZXN0EhUKDXNoYXJlX2xpbmtfaWQYASABKAkihwEKFVNob3dTaGFyZUxpbmtSZXNwb25zZRIZChFlbmNyeXB0ZWRfcGF5bG9hZBgBIAEoDBIiChplbmNyeXB0ZWRfcHJvdGVjdGVkX3NlY3JldBgCIAEoDBIUCgxzZW5kZXJfZW1haWwYAyABKAkSGQoRb3JnYW5pemF0aW9uX25hbWUYBCABKAkyqQEKEFNoYXJlTGlua1NlcnZpY2USTgoHUHJldmlldxIfLmRvbWFpbi5QcmV2aWV3U2hhcmVMaW5rUmVxdWVzdBogLmRvbWFpbi5QcmV2aWV3U2hhcmVMaW5rUmVzcG9uc2UiABJFCgRTaG93EhwuZG9tYWluLlNob3dTaGFyZUxpbmtSZXF1ZXN0Gh0uZG9tYWluLlNob3dTaGFyZUxpbmtSZXNwb25zZSIAQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * @generated from message domain.PreviewShareLinkRequest
 */
export type PreviewShareLinkRequest = Message<"domain.PreviewShareLinkRequest"> & {
  /**
   * NOTE: this is no uuid but an uniuri
   *
   * @generated from field: string share_link_id = 1;
   */
  shareLinkId: string;
};

/**
 * Describes the message domain.PreviewShareLinkRequest.
 * Use `create(PreviewShareLinkRequestSchema)` to create a new message.
 */
export const PreviewShareLinkRequestSchema: GenMessage<PreviewShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_share_link_service, 0);

/**
 * @generated from message domain.PreviewShareLinkResponse
 */
export type PreviewShareLinkResponse = Message<"domain.PreviewShareLinkResponse"> & {
  /**
   * @generated from field: bytes encrypted_payload = 1;
   */
  encryptedPayload: Uint8Array;

  /**
   * @generated from field: string sender_email = 2;
   */
  senderEmail: string;

  /**
   * @generated from field: string organization_name = 3;
   */
  organizationName: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.PreviewShareLinkResponse.
 * Use `create(PreviewShareLinkResponseSchema)` to create a new message.
 */
export const PreviewShareLinkResponseSchema: GenMessage<PreviewShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_share_link_service, 1);

/**
 * @generated from message domain.ShowShareLinkRequest
 */
export type ShowShareLinkRequest = Message<"domain.ShowShareLinkRequest"> & {
  /**
   * NOTE: this is no uuid but an uniuri
   *
   * @generated from field: string share_link_id = 1;
   */
  shareLinkId: string;
};

/**
 * Describes the message domain.ShowShareLinkRequest.
 * Use `create(ShowShareLinkRequestSchema)` to create a new message.
 */
export const ShowShareLinkRequestSchema: GenMessage<ShowShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_share_link_service, 2);

/**
 * @generated from message domain.ShowShareLinkResponse
 */
export type ShowShareLinkResponse = Message<"domain.ShowShareLinkResponse"> & {
  /**
   * @generated from field: bytes encrypted_payload = 1;
   */
  encryptedPayload: Uint8Array;

  /**
   * @generated from field: bytes encrypted_protected_secret = 2;
   */
  encryptedProtectedSecret: Uint8Array;

  /**
   * @generated from field: string sender_email = 3;
   */
  senderEmail: string;

  /**
   * @generated from field: string organization_name = 4;
   */
  organizationName: string;
};

/**
 * Describes the message domain.ShowShareLinkResponse.
 * Use `create(ShowShareLinkResponseSchema)` to create a new message.
 */
export const ShowShareLinkResponseSchema: GenMessage<ShowShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_share_link_service, 3);

/**
 * @generated from service domain.ShareLinkService
 */
export const ShareLinkService: GenService<{
  /**
   * errors:
   * - ShareLinkNotFound (110400): share link not found or already used
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ShareLinkService.Preview
   */
  preview: {
    methodKind: "unary";
    input: typeof PreviewShareLinkRequestSchema;
    output: typeof PreviewShareLinkResponseSchema;
  },
  /**
   * errors:
   * - ShareLinkNotFound (110400): share link not found or already used
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ShareLinkService.Show
   */
  show: {
    methodKind: "unary";
    input: typeof ShowShareLinkRequestSchema;
    output: typeof ShowShareLinkResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_share_link_service, 0);

